import React from 'react'
import styled from 'styled-components'
import dynamic from 'next/dynamic'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'

import { BenefitCard } from 'components/Molecules'
import { useTranslation } from 'i18n-web/i18next'

const Slider = dynamic(() => import('components/Atoms/Slider'), { ssr: false })

const Component = styled.div`
  padding: 60px 0 70px;

  .pagination {
    bottom: -40px !important;
  }

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    padding: 80px 0;
  }
`

const Card = styled(BenefitCard)`
  padding: 0;

  & + & {
    margin-top: 70px;
    padding-top: 70px;
    border-top: solid 1px rgba(55, 56, 64, 0.25);
  }
`

const HowItWorks = () => {
  const { t } = useTranslation()

  return (
    <Component>
      <Grid>
        <Row>
          <Col xs={12} sm={false}>
            <Slider
              options={{
                arrows: false,
                classes: {
                  pagination: 'splide__pagination pagination',
                },
                gap: '32px',
                perMove: 1,
                perPage: 1,
                width: '100vw',
              }}
              items={[
                <Card
                  description={t(
                    'howItWorks.howItWorks.findYourSpace.description'
                  )}
                  image="/static/images/how-it-works/how-it-works/find-your-space@3x.jpg"
                  key="howitworks-card-1"
                  label={t('howItWorks.howItWorks.label')}
                  title={t('howItWorks.howItWorks.findYourSpace.title')}
                />,
                <Card
                  description={t(
                    'howItWorks.howItWorks.parkLikeAPro.description'
                  )}
                  image="/static/images/how-it-works/how-it-works/park-like-a-pro@3x.jpg"
                  key="howitworks-card-2"
                  label={t('howItWorks.howItWorks.label')}
                  title={t('howItWorks.howItWorks.parkLikeAPro.title')}
                />,
                <Card
                  description={t(
                    'howItWorks.howItWorks.playDontPay.description'
                  )}
                  image="/static/images/how-it-works/how-it-works/play-dont-pay@3x.jpg"
                  key="howitworks-card-3"
                  label={t('howItWorks.howItWorks.label')}
                  title={t('howItWorks.howItWorks.playDontPay.title')}
                />,
              ]}
            />
          </Col>
          <Col xs={false} sm={12}>
            <Card
              description={t('howItWorks.howItWorks.findYourSpace.description')}
              image="/static/images/how-it-works/how-it-works/find-your-space@3x.jpg"
              label={t('howItWorks.howItWorks.label')}
              title={t('howItWorks.howItWorks.findYourSpace.title')}
            />
            <Card
              description={t('howItWorks.howItWorks.parkLikeAPro.description')}
              image="/static/images/how-it-works/how-it-works/park-like-a-pro@3x.jpg"
              label={t('howItWorks.howItWorks.label')}
              title={t('howItWorks.howItWorks.parkLikeAPro.title')}
            />
            <Card
              description={t('howItWorks.howItWorks.playDontPay.description')}
              image="/static/images/how-it-works/how-it-works/play-dont-pay@3x.jpg"
              label={t('howItWorks.howItWorks.label')}
              title={t('howItWorks.howItWorks.playDontPay.title')}
            />
          </Col>
        </Row>
      </Grid>
    </Component>
  )
}

export default HowItWorks
